if (!customElements.get('northstar-inventory')) {
  customElements.define('northstar-inventory', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[id^="MainProduct-"]');
      const data = this.querySelector('[data-inventory-variants]');
      if (!this.root || !data) return;
      this.variants = JSON.parse(data.textContent);
      this.onInput = event => {
        if (event.target.matches('[name="id"], [name="quantity"]') || event.target.closest('variant-selects, variant-radios')) this.update();
      };
      this.root.addEventListener('change', this.onInput);
      this.root.addEventListener('input', this.onInput);
      this.update();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('change', this.onInput);
      this.root?.removeEventListener('input', this.onInput);
    }

    update() {
      const form = this.root.querySelector('product-form form');
      const id = form?.querySelector('[name="id"]')?.value || this.dataset.variantId;
      const picker = this.root.querySelector('variant-selects, variant-radios');
      const unavailable = picker && picker.currentVariant === undefined && picker.options;
      const variant = unavailable ? null : this.variants.find(item => String(item.id) === String(id));
      const quantity = Math.max(1, Number(this.root.querySelector('[name="quantity"]')?.value) || 1);
      const stock = this.querySelector('[data-inventory-stock]');
      const backorder = this.querySelector('[data-inventory-backorder]');
      const excess = this.querySelector('[data-inventory-excess]');
      const restockCopy = excess.querySelector('[data-excess-restock]');
      const reduceCopy = excess.querySelector('[data-excess-reduce]');
      let state = 'in-stock';
      if (!variant) state = 'unavailable';
      else if (!variant.available) state = 'sold-out';
      else if (variant.tracked && variant.quantity <= 0 && variant.continue) state = 'backorder';
      else if (variant.tracked && variant.quantity <= Number(this.dataset.threshold)) state = 'low-stock';
      let label = this.dataset.inStock;
      if (state === 'unavailable') label = this.dataset.unavailable;
      else if (state === 'sold-out') label = this.dataset.soldOut;
      else if (state === 'backorder') label = this.dataset.backorder;
      else if (variant.tracked && this.dataset.showQuantity === 'true') {
        label = state === 'low-stock' ? this.dataset.lowStock : this.dataset.inStockQuantity;
      } else if (state === 'low-stock') label = this.dataset.lowStockPlain;
      const count = Math.max(0, variant?.quantity || 0);
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
      stock.textContent = label.replaceAll('[quantity]', formatted);
      stock.dataset.state = state;
      stock.hidden = state !== 'sold-out' && state !== 'unavailable';
      backorder.hidden = state !== 'backorder';
      const exceeds = variant?.available && variant.tracked && variant.quantity > 0 && quantity > variant.quantity;
      excess.hidden = !exceeds;
      restockCopy.hidden = !variant?.continue;
      reduceCopy.hidden = !!variant?.continue;
      reduceCopy.textContent = this.dataset.reduceQuantity.replaceAll('[quantity]', formatted);
      this.dataset.state = state;
      this.hidden = (state === 'in-stock' || state === 'low-stock') && !exceeds;
    }
  });
}